import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate conditions
  const conditionsArray = properties.conditions?.values || [];
  if (conditionsArray.length === 0) {
    errors.push({
      key: 'conditions',
      message: 'At least one condition is required',
    });
  }

  // Validate each condition
  conditionsArray.forEach((condition: any, index: number) => {
    if (!condition.field1 || condition.field1.trim() === '') {
      errors.push({
        key: `conditions.values[${index}].field1`,
        message: 'Field 1 is required',
      });
    }

    if (!condition.operator) {
      errors.push({
        key: `conditions.values[${index}].operator`,
        message: 'Operator is required',
      });
    }

    // Value is required unless operator is isEmpty or isNotEmpty
    if (condition.operator !== 'isEmpty' && condition.operator !== 'isNotEmpty') {
      if (condition.value === undefined || condition.value === null || condition.value === '') {
        errors.push({
          key: `conditions.values[${index}].value`,
          message: 'Value is required for this operator',
        });
      }
    }
  });

  return {
    valid: errors.length === 0,
    errors,
  };
}
